import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { RoomType, UseType } from "@/commons/services/Rooms";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 空床情報 API 操作クラス
 */
export default class RoomsSchedules {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GETS Rooms
   */
  public async gets(userStore: LoginUser, year: number, month: number, queryParams?: { useType?: UseType }): Promise<Array<RoomSchedulesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      year: year,
      month: month
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.RoomsSchedules, formatParams);

    const params: any = queryParams ? queryParams : {};
    const response = await this.commonService.executeGet<Array<RoomSchedulesGetModel>>(userStore, requestUrl, this.constructor.name, params, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface RoomSchedulesGetModel {
  /** 部屋を示す ID */
  id: number;
  /** 部屋名 */
  name: string;
  /** 部屋の用途（入居 or ショートステイ） */
  useType: UseType;
  /** 部屋タイプ（個室 or ２人部屋 or 多床室） */
  roomType: RoomType;
  /** 部屋人数 */
  capacity: number;
  /** フィルタリング用利用者グループID */
  residentGroupId: number;
  /** スケジュール */
  schedules: Array<RoomScheduleModel>;
}

export interface RoomScheduleModel {
  /** 日時 */
  datetime: number;
  /** 入居利用者 */
  residents: Array<RoomScheduleResident>;
}

export interface RoomScheduleResident {
  /** 利用者ID */
  residentId: number;
  /** 利用者名 */
  residentName: string;
  /** 入所日時 */
  inDatetime: number | null;
  /** 退所予定日時 */
  outDatetime: number | null;
}
